import Chip from '@mui/material/Chip';
import LabsIcon from '@apps-common/ui-icons/Flask';
import PropTypes from 'prop-types';
import React from 'react';

const PlanetOnlyChip = ({labIcon = false, ...props}) => (
  <Chip
    label="Planet Only"
    color="yellow"
    size="xsmall"
    variant="filled"
    icon={
      labIcon ? <LabsIcon fontSize="small" sx={{fontSize: '1rem'}} /> : null
    }
    {...props}
  />
);

PlanetOnlyChip.propTypes = {
  labIcon: PropTypes.bool,
};

export default PlanetOnlyChip;
